import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { shadowSm } from '../../../web/styles/shadows';
import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		height: '100%',
		justifyItems: 'center',
	},
	card: {
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		display: 'flex',
		height: `calc(100% - ${SPACE[16]}px)`,
		marginTop: SPACE[16],
		overflow: 'hidden',
		position: 'relative',
		width: '100%',
	},
	stackedCard: {
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		height: `calc(100% - ${SPACE[32]}px)`,
		left: '50%',
		opacity: 0.4,
		position: 'absolute',
		transform: 'translateX(-50%)',
	},
	stackedCardBack: {
		top: 0,
		width: `calc(100% - ${SPACE[48]}px)`,
	},
	stackedCardMiddle: {
		top: SPACE[8],
		width: `calc(100% - ${SPACE[16]}px)`,
	},
	queueRoot: {
		boxSizing: 'border-box',
		paddingTop: SPACE[16],
		height: '100%',
		width: '100%',
		display: 'grid',
		justifyItems: 'center',
		overflowY: 'hidden',
		overflowX: 'auto',
	},
	queueContainer: {
		display: 'flex',
		justifyContent: 'center',
		minWidth: THEME.breakpoints.md,
		maxWidth: 1400,
		overflow: 'hidden',
		paddingBottom: SPACE[16],
		boxSizing: 'border-box',
		paddingLeft: SPACE[16],
		paddingRight: SPACE[16],
		height: '100%',
		position: 'relative',
		width: '100%',
	},
	sunShade: {
		alignItems: 'center',
		color: THEME.colors.text.main,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		height: '100%',
		justifyContent: 'center',
		padding: SPACE[24],
		textAlign: 'center',
		width: '100%',
		...CssSelectors.allChildren({ margin: 0 }, 'p'),
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		paddingBottom: SPACE[24],
		overflow: 'hidden',
	},
	settingsPanel: {
		padding: SPACE[20],
	},
	settingsPanelTitle: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: SPACE[8],
		marginTop: 0,
		color: THEME.colors.text.light,
	},
	settingsSection: {
		paddingBottom: SPACE[4],
	},
	settingsSectionDivider: {
		marginTop: SPACE[16],
		paddingTop: SPACE[16],
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
	openFocusedViewLink: {
		marginTop: SPACE[8],
		paddingLeft: 0,
		paddingRight: 0,
	},
});
